function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 3C9.59653 3 7.41322 3.94259 5.79925 5.47781L3.74572 3.42428C3.3355 3.01406 3 3.15307 3 3.73325L3 8.37388C3 9.27026 3.14665 9.42857 4.05469 9.42857H8.69531C9.2755 9.42857 9.4145 9.09307 9.00428 8.68285L7.39072 7.06928C8.6455 5.89447 10.2731 5.25 12 5.25C13.8028 5.25 15.4979 5.95232 16.7728 7.22719C18.0477 8.50206 18.75 10.1972 18.75 12C18.75 13.8028 18.0477 15.4979 16.7728 16.7732C15.4979 18.0477 13.8028 18.75 12 18.75C10.1972 18.75 8.50206 18.0477 7.22719 16.7728C7.12072 16.6663 7.01866 16.5567 6.92022 16.4446L5.2271 17.9263C6.87682 19.8103 9.29919 21 12 21C16.9705 21 21 16.9705 21 12C21 7.0295 16.9705 3 12 3Z",
  fill: "black"
});
const SvgResetfreshIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResetfreshIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resetfresh-icon.74af3d9b.svg";
export { ForwardRef as ReactComponent };